import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { KioskDoubleButtonFooterBlockConfig } from '@front-platform/content-builder';
import { kioskDoubleButtonFooterBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import { Router } from '@angular/router';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { AnalyticsService } from '@core/services/app/analytics.service';
export interface KioskDoubleButtonFooterBlockRuntimeConfig {}

export type KioskDoubleButtonFooterBlockConfigInput = Partial<
  Omit<KioskDoubleButtonFooterBlockConfig, keyof KioskDoubleButtonFooterBlockRuntimeConfig> &
    KioskDoubleButtonFooterBlockRuntimeConfig
>;
export type KioskDoubleButtonFooterBlockResolvedConfig = Omit<
  KioskDoubleButtonFooterBlockConfig,
  keyof KioskDoubleButtonFooterBlockRuntimeConfig
> &
  Partial<KioskDoubleButtonFooterBlockRuntimeConfig>;
export interface KioskDoubleButtonFooterBlockContract extends ConfigComponentContract<
  KioskDoubleButtonFooterBlockConfigInput,
  KioskDoubleButtonFooterBlockResolvedConfig
> {}

@Component({
  selector: 'app-kiosk-double-button-footer-block',
  templateUrl: './kiosk-double-button-footer-block.component.html',
  standalone: false,
})
export class KioskDoubleButtonFooterBlockComponent implements KioskDoubleButtonFooterBlockContract {
  readonly config = input<KioskDoubleButtonFooterBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    KioskDoubleButtonFooterBlockConfig,
    KioskDoubleButtonFooterBlockRuntimeConfig
  >(kioskDoubleButtonFooterBlockResolveConfig, () => ({ config: this.config() }));
  get backgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get textColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor | undefined;
  }
  get primaryButtonBackgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['primary_button_background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get primaryButtonTextColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['primary_button_text_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get primaryButtonLabel(): string | undefined {
    return this.resolvedConfig()['primary_button_label'] as unknown as string | undefined;
  }
  get primaryButtonLink(): string | undefined {
    return this.resolvedConfig()['primary_button_link'] as unknown as string | undefined;
  }
  get secondaryButtonBackgroundColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['secondary_button_background_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get secondaryButtonTextColor(): IContentBuilderFieldColor | undefined {
    return this.resolvedConfig()['secondary_button_text_color'] as unknown as
      IContentBuilderFieldColor | undefined;
  }
  get secondaryButtonLabel(): string | undefined {
    return this.resolvedConfig()['secondary_button_label'] as unknown as string | undefined;
  }
  get secondaryButtonLink(): string | undefined {
    return this.resolvedConfig()['secondary_button_link'] as unknown as string | undefined;
  }
  get displaySecondButton(): boolean | undefined {
    return this.resolvedConfig()['display_second_button'] as unknown as boolean | undefined;
  }

  constructor(
    private readonly router: Router,
    private readonly helperRouter: RouterHelperService,
    private readonly analyticsService: AnalyticsService,
  ) {}

  navigateTo(navigateTo: string | undefined) {
    if (navigateTo) {
      this.router.navigate([this.helperRouter.translateRoute(navigateTo)]);
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(KioskDoubleButtonFooterBlockComponent, {
  'keyAliases': {},
});
